import {HTMLAttributes} from 'react';
import {Divider} from '../../../../design-system/atoms/Divider/Divider';
import {Text} from '../../../../design-system/atoms/Text/Text';
import {theme} from '../../../../theme';

export interface AccountInfoBoxProps extends HTMLAttributes<HTMLDivElement> {
  description?: string;
  title: string;
  rightButton?: React.ReactElement;
}

export function AccountInfoBox({
  description,
  title,
  rightButton,
  ...props
}: AccountInfoBoxProps) {
  return (
    <div {...props}>
      <div className="flex items-center py-20pxr px-15pxr">
        <div className="flex flex-1 flex-col">
          {description && (
            <div>
              <Text className="font-small2 mb-4pxr text-theme-solid-40">
                {description}
              </Text>
            </div>
          )}

          {title && (
            <div>
              <Text className="text-theme-solid-100">{title}</Text>
            </div>
          )}
        </div>
        {rightButton}
      </div>

      <Divider
        className="mx-15pxr"
        color={theme.colors['theme-transparent-10']}
      />
    </div>
  );
}
